// Non-secret constants. Google OAuth Client ID is the `aud` claim our
// server verifies on Google ID tokens — it's by design embedded in the
// frontend bundle, not a secret.

export const GOOGLE_CLIENT_ID =
  "747028422113-vi2f6bdeeoc6afr2hu6d8bq3rc74mk9o.apps.googleusercontent.com";

export const API_BASE = "https://api.clubmanager.alpenglowsoftware.net";
